import {
  useMutation,
  useQuery,
  useQueryClient,
  QueryClient,
} from "@tanstack/react-query";
import * as client from "../../../client";

const saveFilters = (
  response: client.ListSavedFiltersResponse,
  qc?: QueryClient
) => {
  qc?.setQueryData(["saved-filters"], response);
  localStorage.setItem("saved-filters", JSON.stringify(response));
};
const loadFilters = (): client.ListSavedFiltersResponse | undefined => {
  const data = localStorage.getItem("saved-filters");
  return data ? JSON.parse(data) : undefined;
};

export const useListSavedFilters = () => {
  return useQuery({
    queryKey: ["saved-filters"],
    queryFn: async () => {
      const response =
        await client.acropolisListSavedFiltersAcropolisListSavedFiltersPost();
      saveFilters(response);
      return response;
    },
    refetchOnWindowFocus: false,
    initialData: loadFilters,
  });
};

export const useAddSavedFilter = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      url,
      isDefault,
      nickname,
    }: {
      url: string;
      nickname: string;
      isDefault: boolean;
    }) =>
      client.acropolisAddSavedFilterAcropolisAddSavedFilterPost({
        requestBody: { url, is_default: isDefault, nickname },
      }),
    onSuccess: (response) => saveFilters(response, queryClient),
  });
};

export const useUpdateSavedFilter = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      nickname,
      isDefault,
    }: {
      id: string;
      nickname: string;
      isDefault: boolean;
    }) =>
      client.acropolisUpdateSavedFilterAcropolisUpdateSavedFilterPost({
        requestBody: { id, is_default: isDefault, nickname },
      }),
    onSuccess: (response) => saveFilters(response, queryClient),
  });
};

export const useDeleteSavedFilter = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string }) =>
      client.acropolisDeleteSavedFilterAcropolisDeleteSavedFilterPost({
        requestBody: { id },
      }),
    onSuccess: (response) => saveFilters(response, queryClient),
  });
};
